export const RAZORPAYS_RESET_STATE = 'RAZORPAYS_RESET_STATE';
export const RAZORPAYS_CURRENT_ITEM = 'RAZORPAYS_CURRENT_ITEM';

export const RAZORPAYS_REQUEST_LOADING = 'RAZORPAYS_REQUEST_LOADING';
export const RAZORPAYS_REQUEST_SUCCESS = 'RAZORPAYS_REQUEST_SUCCESS';
export const RAZORPAYS_REQUEST_FAILED = 'RAZORPAYS_REQUEST_FAILED';

export const RAZORPAYS_CURRENT_ACTION = 'RAZORPAYS_CURRENT_ACTION';
export const RAZORPAYS_RESET_ACTION = 'RAZORPAYS_RESET_ACTION';